import apiClient from "./axios"

// Fetch all vehicle stocks with optional query params (pagination, search, filters)
export const getVehicleStocks = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stocks", { params })
  return data
}

// Generate pdf all vehicle stocks with optional query params (pagination, search, filters)
export const getVehicleStocksPdf = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stocks/pdf", { params })
  return data
}

// Vehicle movements
export const getVehicleStockMovements = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stocks/movements", { params })
  return data
}

// Fetch vehicle options by full chassis or stock id for autocomplete
export const getVehicleOptions = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stocks/options", { params })
  return data
}

export const downloadVehicleStockPdf = async (params = {}) => {
  try {
    const response = await apiClient.get("/vehicle-stocks/pdf/download", {
      params,
      responseType: "blob", // important for PDF
    })

    // Create a Blob from the response
    const file = new Blob([response.data], { type: "application/pdf" })

    // Create a blob URL
    const fileURL = URL.createObjectURL(file)

    // Open PDF in a new tab
    window.open(fileURL, "_blank")
  } catch (error) {
    console.error("Failed to open PDF:", error)
  }
}

// Fetch a single vehicle stock by ID
export const getVehicleStock = async id => {
  const { data } = await apiClient.get(`/vehicle-stocks/${id}`)
  return data
}

// Fetch vehicle stocks by location ID
export const getVehicleStocksByLocation = async (locationId, params = {}) => {
  const { data } = await apiClient.get(
    `/vehicle-stocks/location/${locationId}`,
    { params }
  )
  return data
}

// Create a new vehicle stock
export const createVehicleStock = async stockData => {
  const { data } = await apiClient.post("/vehicle-stocks", stockData)
  return data
}

// Quick-onboard a standalone vehicle from a vehicle_info payload
export const onboardVehicleStock = async vehicleInfo => {
  const { data } = await apiClient.post("/vehicle-stocks/onboard", {
    vehicle_info: vehicleInfo,
  })
  return data
}

// Create bulk vehicle stock
export const createBulkVehicleStock = async stockData => {
  const { data } = await apiClient.post("/vehicle-stocks/bulk", stockData)
  return data
}

// Tag importer by full chassis/stock id
export const tagImporter = async (params) => {
  const { data } = await apiClient.post("/vehicle-stocks/tag-importer", params)
  return data
}

// Edit/update an existing vehicle stock
export const editVehicleStock = async ({ id, ...stockData }) => {
  const { data } = await apiClient.patch(`/vehicle-stocks/${id}`, stockData)
  return data
}

// Delete a vehicle stock by ID
export const deleteVehicleStock = async id => {
  const { data } = await apiClient.delete(`/vehicle-stocks/${id}`)
  return data
}

// Verify if a full_chassis exists
export const verifyFullChassis = async params => {
  const { data } = await apiClient.get("/vehicle-stocks/verify-full-chassis", {
    params: { ...params },
    skipToast: true,
  })
  return data
}

// Download vehicle zip images as blob
export const downloadVehicleZipImages = async (identifier, params = {}) => {
  const response = await apiClient.get(
    `/vehicle-stocks/${identifier}/zip/download`,
    {
      responseType: "blob",
      params: { ...params },
      skipToast: true,
    }
  )

  return response
}
